// import 'url-search-params-polyfill'
import { BASE_URL, fetchHeaders } from "./common";

export const getGroupListData = () => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken
  };

  return fetch(BASE_URL + "adminGetGroupList", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const getOrgListData = () => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken
  };

  return fetch(BASE_URL + "adminGetOrgList", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};


export const getOrgListDataORG = () => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken
  };

  return fetch(BASE_URL + "adminGetOrgList", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const getUserListData = (deptCode) => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken
  };

  if (deptCode != null) params.deptCode = deptCode + '';

  console.log("getUserListData", params);

  return fetch(BASE_URL + "adminGetUserList", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });

};

export const getPartnerListData = deptCode => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken
  };

  if (deptCode != null) params.deptCode = deptCode;

  console.log("getUserListData", params);

  return fetch(BASE_URL + "adminGetPartnerList", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const getUserListByGroup = groupCode => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    groupCode
  };

  console.log("getUserListByGroup", params);

  return fetch(BASE_URL + "adminGetUserListByGroup", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const createModifyGroup = (
  groupCode,
  groupName,
  groupEmail,
  parentGroupCode,
  groupLevel,
  quotaType,
  password,
  mailQuota,
  maxAttachSize,
  memberList,
  deletedList
) => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    groupCode,
    groupName,
    groupEmail,
    parentGroupCode,
    groupLevel,
    quotaType,
    password,
    mailQuota,
    maxAttachSize,
    memberList: JSON.stringify(memberList),
    deletedList: JSON.stringify(deletedList)
  };

  console.log("createModifyGroup", params);

  return fetch(BASE_URL + "adminCreateModifyGroup", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const deleteGroup = groupCode => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    groupCode
  };

  console.log("groupCode", params);

  return fetch(BASE_URL + "adminDeleteGroup", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const getAccountInfoData = emailId => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    emailId
  };

  console.log("getAccountInfoData", params);

  return fetch(BASE_URL + "adminGetAccountInfo", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const createAccountInfoData = (
  userName,
  emailId,
  password,
  groupCode,
  groupName,
  attrs,
  quotaType
) => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    userName,
    emailId,
    password,
    groupCode,
    groupName,
    attrs: JSON.stringify(attrs),
    quotaType
  };

  console.log("adminCreateAccountInfo", params);

  return fetch(BASE_URL + "adminCreateAccountInfo", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const modifyAccountInfoData = (
  emailId,
  password,
  attrs,
  groupCode,
  groupName,
  quotaType
) => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    emailId,
    password,
    attrs: JSON.stringify(attrs),
    groupCode,
    groupName,
    quotaType
  };

  console.log("modifyAccountInfoData", params);

  return fetch(BASE_URL + "adminModifyAccountInfo", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};


export const deleteAccountInfoData = async (
  emailIds,
  zimbraIds,
) => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    emailIds,
    zimbraIds
  };

  console.log("modifyAccountInfoData", params);

  return fetch(BASE_URL + "adminDeleteAccountInfo", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const getAllDistributionList = async domainName => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    domainName
  };

  return fetch(BASE_URL + "adminGetAllDistributionList", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const getAllQuotaUsage = async domainName => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    domainName
  };

  return fetch(BASE_URL + "adminGetQuotaUsage", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const createDistribution = async (newName, newEmail, attrs) => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    newEmail,
    newName,
    attrs: JSON.stringify(attrs)
  };

  console.log("XXX", params);

  return fetch(BASE_URL + "adminCreateDistribution", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const modifyDistribution = async (
  distributeZimbraId,
  newName,
  attrs
) => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    distributeZimbraId,
    newName,
    attrs: JSON.stringify(attrs)
  };

  return fetch(BASE_URL + "adminModifyDistribution", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const deleteDistribution = async distributionZimbraId => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    distributionZimbraId
  };

  return fetch(BASE_URL + "adminDeleteDistribution", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const getAllZimbraConfig = async () => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken
  };

  return fetch(BASE_URL + "adminGetAllZimbraConfig", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const modifyZimbraConfig = async attrs => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    attrs: JSON.stringify(attrs)
  };

  return fetch(BASE_URL + "adminModifyZimbraConfig", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const getAllUCConfig = async () => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken
  };

  return fetch(BASE_URL + "adminGetUCConfig", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const saveUCConfig = async reqConfig => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    reqConfig: JSON.stringify(reqConfig)
  };

  return fetch(BASE_URL + "adminSetUCConfig", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const getLoggerStats = async (statsName, startTime, endTime) => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    statsName,
    startTime,
    endTime
  };

  console.log("getLoggerStats.params", params);

  return fetch(BASE_URL + "adminGetLoggerStats", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};

export const downloadBackup = async types => {
  const adminZimbraToken = sessionStorage.getItem("adminZimbraToken");

  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    adminZimbraToken,
    types
  };

  console.log("getLoggerStats.params", params);

  return fetch(BASE_URL + "adminBackup", {
    method: "POST",
    headers: fetchHeaders,
    body: JSON.stringify(params)
  });
};
